<template>
  <div class="animated fadeIn">
    <div class="row mb-20">
      <div class="col-6">
        <a @click="openPage('/allForm')" class="btn-grey"><i class="fas fa-arrow-circle-left mr-5"></i>Back</a>
      </div>
    </div>
    <div class="box">
      <div class="p-20">
        <div class="row mt-10">
          <div class="col-sm-6">
            <b-row>
              <b-col sm="3">
                <label>Type</label>
              </b-col>
              <b-col sm="9">
                <b-form-select @change="changeFormType" name="formType" v-model="formType" :options="options"
                  class="mb-3" />
              </b-col>
            </b-row>
          </div>
          <div class="col-sm-6">
            <b-row>
              <b-col sm="3">
                <label>Branch</label>
              </b-col>
              <b-col sm="9">
                <b-form-select name="branch" v-model="addData.branch_id" @change="changeBranch">
                  <option :value="null">Please select</option>
                  <option v-for="item in dataBranch" :key="item.id" :value="item.id">{{ item.name }}</option>
                </b-form-select>
              </b-col>
            </b-row>
          </div>
        </div>
        <template v-if="formType === 'freeze'">
          <form @submit.prevent="validateFreeze('freeze')" data-vv-scope="freeze">
            <div class="row justify-content-center mt-30">
              <div class="col-sm-6">
                <b-row class="mb-20">
                  <b-col sm="3">
                    <label>Member ID</label>
                  </b-col>
                  <b-col sm="9">
                    <div class="custom-search-select">
                      <model-select @searchchange="searchMember" :options="optionsMember" class="border-bottom"
                        name="member_id" v-validate="'required'" v-model="addData.member_id"></model-select>
                    </div>
                    <span class="error">{{ errors.first('wristband.member_id') }}</span>
                  </b-col>
                </b-row>
                <b-row class="mb-20">
                  <b-col sm="3">
                    <label>Member Name</label>
                  </b-col>
                  <b-col sm="9">
                    <b-form-input class="border-bottom bg-transparent" disabled v-model="fullNameDetail"
                      type="text"></b-form-input>
                  </b-col>
                </b-row>
                <b-row class="mb-20">
                  <b-col sm="3">
                    <label>Phone Number</label>
                  </b-col>
                  <b-col sm="9">
                    <b-form-input class="border-bottom bg-transparent" disabled v-model="detailMember.phone_number"
                      type="text"></b-form-input>
                  </b-col>
                </b-row>
                <b-row class="mb-20">
                  <b-col sm="3">
                    <label>Email</label>
                  </b-col>
                  <b-col sm="9">
                    <b-form-input class="border-bottom bg-transparent" disabled v-model="detailMember.email"
                      type="text"></b-form-input>
                  </b-col>
                </b-row>
                <b-row class="mb-20">
                  <b-col sm="3">
                    <label>Membership Type</label>
                  </b-col>
                  <b-col sm="9">
                    <b-form-input class="border-bottom bg-transparent" disabled
                      v-model="detailMember.membership_last_buy_name" type="text"></b-form-input>
                  </b-col>
                </b-row>
                <b-row class="mb-20">
                  <b-col sm="3">
                    <label>Join Date</label>
                  </b-col>
                  <b-col sm="9">
                    <b-form-input class="border-bottom bg-transparent" disabled v-model="detailMember.start_membership"
                      type="text"></b-form-input>
                  </b-col>
                </b-row>
              </div>
              <div class="col-sm-6">
                <b-row class="mb-20">
                  <b-col sm="3">
                    <label>Freeze Category</label>
                  </b-col>
                  <b-col sm="9">
                    <b-form-select class="border-bottom" name="freeze_category_id" v-validate="'required'"
                      v-model="addData.freeze_category_id">
                      <option :value="0">Please select</option>
                      <option v-for="item in freeze_category" :key="item.id" :value="item.id">{{ item.name }}</option>
                    </b-form-select>
                    <span class="error">{{ errors.first('freeze.freeze_category_id') }}</span>
                  </b-col>
                </b-row>
                <b-row class="mb-20" v-if="addData.freeze_category_id == 2">
                  <b-col sm="3">
                    <label>Member Rating</label>
                  </b-col>
                  <b-col sm="9">
                    <b-form-select class="border-bottom" name="member_rating" v-model="addData.member_rating">
                      <option :value="0">Please select</option>
                      <option :value="1">1</option>
                      <option :value="2">2</option>
                      <option :value="3">3</option>
                    </b-form-select>
                  </b-col>
                </b-row>
                <b-row class="mb-20">
                  <b-col sm="3">
                    <label>Freeze Duration</label>
                  </b-col>
                  <b-col sm="9">
                    <b-form-select @change="changeDuration" class="border-bottom" name="freeze_duration"
                      v-validate="'required'" v-model="addData.freeze_duration">
                      <option :value="null">Please select</option>
                      <option v-for="(month, index) in 10" :value="month" :key="index">{{ month }}</option>
                    </b-form-select>
                    <span class="error">{{ errors.first('freeze.freeze_duration') }}</span>
                  </b-col>
                </b-row>
                <b-row class="mb-20">
                  <b-col sm="3">
                    <label>Effective Date</label>
                  </b-col>
                  <b-col sm="9">
                    <flat-pickr :config="config" v-model="addData.effective_date" v-validate="'required'"
                      name="event_date" class="w-100 border-bottom"></flat-pickr>
                    <span class="error">{{ errors.first('freeze.effective_date') }}</span>
                  </b-col>
                </b-row>
                <b-row class="mb-20">
                  <b-col sm="3">
                    <label>Freeze Revenue</label>
                  </b-col>
                  <b-col sm="9">
                    <money class="form-control border-bottom bg-transparent" name="freeze_revenue"
                      v-model="addData.freeze_revenue" :value="totalPayment" v-bind="money2"></money>
                    <span class="error">{{ errors.first('freeze.freeze_revenue') }}</span>
                  </b-col>
                </b-row>
                <b-row class="mb-20">
                  <b-col sm="3">
                    <label>Detail Reason</label>
                  </b-col>
                  <b-col sm="9">
                    <b-form-input class="border-bottom" v-model="addData.detail_reason" type="text"></b-form-input>
                  </b-col>
                </b-row>
                <b-row class="mb-20">
                  <b-col sm="3">
                    <label>Employee ID</label>
                  </b-col>
                  <b-col sm="9">
                    <b-form-select @change="getCSData" class="border-bottom" name="customer_service_id"
                      v-validate="'required'" v-model="addData.customer_service_id">
                      <option :value="null">Please select</option>
                      <option v-for="item in dataCS" :key="item.id" :value="item.id">
                        <template v-if="item.branch">{{ item.branch.codename }}</template><template
                          v-else>XX</template>-{{ item.id }}
                      </option>
                    </b-form-select>
                    <span class="error">{{ errors.first('freeze.customer_service_id') }}</span>
                  </b-col>
                </b-row>
                <b-row class="mb-20">
                  <b-col sm="3">
                    <label>Customer Service Name</label>
                  </b-col>
                  <b-col sm="9">
                    <b-form-input class="border-bottom bg-transparent" disabled v-model="CSName"
                      type="text"></b-form-input>
                  </b-col>
                </b-row>
              </div>
            </div>
            <div class="mb-10">
              <div>Payment Methods</div>
              <hr class="short-line left mb-20">
              <div class="row">
                <div class="col-lg-7">
                  <b-row class="mb-20">
                    <b-col sm="3">
                      <div>Payment 1</div>
                    </b-col>
                    <b-col sm="9">
                      <div class="mb-20">
                        <b-form-select v-validate="'required'" @change="changePaymentType1" name="payment_type_id_1"
                          v-model="addData.payment_type_id_1" class="form-control border-bottom">
                          <option :value="null" selected>Please select</option>
                          <option v-for="item in itemsPaymentType" :key="item.id" :value="item.id">{{ item.name }}
                          </option>
                        </b-form-select>
                        <span class="error">{{ errors.first('freeze.payment_type_id_1') }}</span>
                      </div>
                      <div class="mb-10">
                        <b-form-radio-group class="radio-custom-list" @change="changePaymentCard1"
                          :disabled="[1, 6, 9].includes(addData.payment_type_id_1)" name="paymentCard1"
                          v-model="addData.payment_card_id_1">
                          <b-form-radio class="font-13" v-for="item in itemsPaymentCard" :key="item.id"
                            :value="item.id">{{ item.name }}</b-form-radio>
                        </b-form-radio-group>
                        <div
                          v-if="![1, 9].includes(addData.payment_type_id_1) && addData.payment_type_id_1 != null && addData.payment_card_id_1 == null">
                          <span class="error">The payment_card_id_1 field is required.</span>
                        </div>
                      </div>
                    </b-col>
                  </b-row>
                </div>
                <div class="col-lg-5">
                  <money class="form-control border-bottom custom-currency w-100" id="paymentFirstAmount"
                    v-model="amountPaymentCard1" v-bind="money2"></money>
                  <div v-if="amountPaymentCard1 == '' || amountPaymentCard1 == null">
                    <span class="error">The payment first amount field is required.</span>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-7">
                  <b-row class="mb-20">
                    <b-col sm="3">
                      <div>Payment 2</div>
                    </b-col>
                    <b-col sm="9">
                      <div class="mb-20">
                        <b-form-select name="payment_type_id_2" @change="changePaymentType2"
                          v-model="addData.payment_type_id_2" class="form-control border-bottom">
                          <option :value="null" selected>Please select</option>
                          <option v-for="item in itemsPaymentType2" :key="item.id" :value="item.id">{{ item.name }}
                          </option>
                        </b-form-select>
                      </div>
                      <div class="mb-10">
                        <b-form-radio-group class="radio-custom-list" @change="changePaymentCard2"
                          :disabled="addData.payment_type_id_2 == 1 || addData.payment_type_id_2 == 6"
                          name="paymentCard2" v-model="addData.payment_card_id_2">
                          <b-form-radio class="font-13" v-for="item in itemsPaymentCard" :key="item.id"
                            :value="item.id">{{ item.name }}</b-form-radio>
                        </b-form-radio-group>
                      </div>
                    </b-col>
                  </b-row>
                </div>
                <div class="col-lg-5">
                  <money class="form-control border-bottom custom-currency w-100 bg-transparent" disabled
                    v-model="amountPaymentCard2" :value="paymentLeft" v-bind="money2"></money>
                </div>
              </div>
              <div class="row">
                <b-col sm="2">
                  <div>Notes</div>
                </b-col>
                <b-col sm="10">
                  <textarea class="w-100" rows="5" v-model="addData.notes"></textarea>
                </b-col>
              </div>
            </div>
            <div class="text-right">
              <button :disabled="disableBtnSubmit" type="submit" class="btn-primary">Submit</button>
            </div>
          </form>
        </template>
      </div>
    </div>
    <div v-if="loadingActive == true" class="loading-container">
      <div class="wrap-screen w-100 h-100">
        <img :src="`/svg-loaders/oval.svg`" width="60" alt="">
        <div class="title-loading color-white">Loading...</div>
      </div>
    </div>
  </div>
</template>

<script>
import { Callout } from '@coreui/vue'
import axios from 'axios'
import { Auth } from '@/api'
import moment from 'moment'
import { ModelSelect } from 'vue-search-select'
import Mixin from '../../mixins/memberMixin'

export default {
  name: 'addFreeze',
  components: {
    ModelSelect
  },
  mixins: [Mixin],

  data: function () {
    return {
      loadingActive: false,
      freeze_category: [],
      disableBtnSubmit: false,
      fullNameDetail: '',
      dataMember: [],
      dataBranch: [],
      dataCS: [],
      config: {
        altInput: true,
        altFormat: 'F j, Y',
        dateFormat: 'Y-m-d'
      },
      money: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 0,
        masked: false
      },
      money2: {
        decimal: ',',
        thousands: '.',
        prefix: 'IDR ',
        suffix: '',
        precision: 0,
        masked: false
      },
      formType: 'freeze',
      itemsPaymentCard: [],
      itemsPaymentType: [],
      itemsPaymentType2: [],
      detailMember: {},
      detailCS: {},
      fullName: '',
      CSName: '',
      amountPaymentCard1: '',
      amountPaymentCard2: '',
      addData: {
        branch_id: null,
        member_id: null,
        customer_service_id: null,
        freeze_duration: 1,
        effective_date: moment(new Date()).format('YYYY-MM-DD'),
        freeze_revenue: '',
        detail_reason: '',
        payment_type_id_1: null,
        payment_card_id_1: null,
        payment_amount_1: '',
        payment_type_id_2: null,
        payment_card_id_2: null,
        payment_amount_2: '',
        notes: '',
        freeze_category_id: 0,
        member_rating: 0
      },
      addDataPrivy: {
        member_id: null,
        customer_id: null,
        branch_id: null,
        doc_name: 'freeze_form.hbs'
      },
      options: [
        { value: null, text: 'Please select' },
        { value: 'freeze', text: 'Freeze' },
        { value: 'cancel', text: 'Cancel' },
        { value: 'outstanding', text: 'Outstanding' },
        { value: 'wristband', text: 'Wristband' },
        { value: 'lostAndFound', text: 'Lost & Found' },
        { value: 'dailyVisit', text: 'Daily Visit' },
        { value: 'grabAndGo', text: 'Grab & Go' },
        { value: 'grabAndGoGopay', text: 'Grab & Go Gopay' }
      ],
      optionsMember: [
        { value: null, text: 'Please select' }
      ],
      checked: false,
      checked2: false
    }
  },
  methods: {
    changeDuration(event) {
      this.addData.freeze_revenue = event * 200000
    },
    changeFormType(event) {
      if (event === 'freeze') {
        this.$router.push('/allForm/addFreeze')
      } else if (event === 'cancel') {
        this.$router.push('/allForm/addCancel')
      } else if (event === 'outstanding') {
        this.$router.push('/allForm/addOutstanding')
      } else if (event === 'wristband') {
        this.$router.push('/allForm/addWristband')
      } else if (event === 'lostAndFound') {
        this.$router.push('/allForm/addLostAndFound')
      } else if (event === 'dailyVisit') {
        this.$router.push('/allForm/addDailyVisit')
      } else if (event === 'grabAndGo') {
        this.$router.push('/allForm/addGrabAndGo')
      } else {
        this.$router.push('/allForm/add')
      }
    },
    async changePaymentCard1(event) {
      let payment_card = await axios.get('transaction/v1/payment_type?sorting=id&sorting_type=asc&status=active&payment_card_id=' + event)
      this.itemsPaymentType = payment_card.data.data.rows
    },
    async changePaymentCard2(event) {
      let payment_card = await axios.get('transaction/v1/payment_type?sorting=id&sorting_type=asc&status=active&payment_card_id=' + event)
      this.itemsPaymentType2 = payment_card.data.data.rows
    },
    changePaymentType1(event) {
      if (event === 1) {
        this.addData.payment_card_id_1 = null
      } else if (event === 6) {
        this.addData.payment_card_id_1 = 1
      } else {
        this.addData.payment_card_id_1 = null
      }
    },
    changePaymentType2(event) {
      if (event === 1) {
        this.addData.payment_card_id_2 = null
      } else if (event === 6) {
        this.addData.payment_card_id_2 = 1
      } else {
        this.addData.payment_card_id_2 = null
      }
    },
    getCSData(event) {
      axios.get('crm/v1/customer_service/' + event).then(response => {
        this.detailCS = response.data.data
        this.CSName = response.data.data.name
        this.addDataPrivy.customer_id = response.data.data.id
        // console.log('test', response)
      }).catch(error => {
        console.log('error', error)
      })
    },
    validateFreeze(data1) {
      if (this.addData.freeze_category_id == 2 && (this.addData.member_rating == 0 || this.addData.member_rating == null)) {
        this.$toast.success('please choose member rating!', 'Error', {
          position: 'topCenter',
          icon: 'icon-envelope',
          progressBarColor: 'rgb(0, 255, 184)',
          theme: 'dark',
          backgroundColor: '#565c70',
          messageColor: '#fff'
        })
        return
      } else if (this.addData.freeze_category_id == 0 || this.addData.freeze_category_id == null) {
        this.$toast.success('please choose freeze category!', 'Error', {
          position: 'topCenter',
          icon: 'icon-envelope',
          progressBarColor: 'rgb(0, 255, 184)',
          theme: 'dark',
          backgroundColor: '#565c70',
          messageColor: '#fff'
        })
        return
      }

      this.$validator.validateAll(data1).then((result) => {
        if (![1, 9].includes(this.addData.payment_type_id_1) && this.addData.payment_card_id_1 == null) {
          this.$toast.success('please fill in required fields!', 'Error', {
            position: 'topCenter',
            icon: 'icon-envelope',
            progressBarColor: 'rgb(0, 255, 184)',
            theme: 'dark',
            backgroundColor: '#565c70',
            messageColor: '#fff'
          })
          return
        }
        if (result) {
          this.addData.payment_amount_1 = this.amountPaymentCard1
          this.addData.payment_amount_2 = this.amountPaymentCard2
          delete this.addData.id

          this.$swal({
            title: 'Are you sure?',
            text: 'You are about to submit this data and waiting for approval',
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, Submit now!',
            cancelButtonText: 'No, Cancel it!',
            showCloseButton: true,
            showLoaderOnConfirm: false
          }).then((confirm) => {
            if (confirm.value) {
              const payload = {
                entity_id: this.$route.query.id,
                request_data: this.addData,
                action: 'EDIT',
                notes: 'Update Form Freeze',
                module_type: 'FORM_FREEZE',
              }

              this.loadingActive = true
              // add to approval request
              axios.post('/crm/v1/approval_request/get_aprroval', payload).then(response => {
                this.loadingActive = false
                console.log('Response', response.data)
                this.$swal('Successfully!', 'Data has been submitted and waiting for approval!', 'success')
                // this.fetchData()
              }).catch((error) => {
                this.loadingActive = false
                console.log('Error', error)
                this.$swal('Failed!', 'Data has been waiting for approval!', 'error')
              })
            }
          })


          // axios.put('crm/v1/form_freeze/' + this.$route.query.id, this.addData)
          // .then(response => {
          //   this.$toast.success('data saved successfully!', 'Success', {
          //     position: 'topCenter',
          //     icon: 'icon-envelope',
          //     progressBarColor: 'rgb(0, 255, 184)',
          //     theme: 'dark',
          //     backgroundColor: '#565c70',
          //     messageColor: '#fff'
          //   })
          //   this.$router.push('/allForm')
          // }).catch(error => {
          //   this.$toast.success('cant saved data!', 'Error', {
          //     position: 'topCenter',
          //     icon: 'icon-envelope',
          //     progressBarColor: 'rgb(0, 255, 184)',
          //     theme: 'dark',
          //     backgroundColor: '#565c70',
          //     messageColor: '#fff'
          //   })
          // })
        } else {
          this.$toast.success('please fill in required fields!', 'Error', {
            position: 'topCenter',
            icon: 'icon-envelope',
            progressBarColor: 'rgb(0, 255, 184)',
            theme: 'dark',
            backgroundColor: '#565c70',
            messageColor: '#fff'
          })
        }
      })
    },
    changeBranch(event) {
      this.addData.customer_service_id = null
      this.addData.member_id = null
      this.getMember()
      axios.get('crm/v1/customer_service?branch_id=' + event).then(response => {
        this.dataCS = response.data.data.rows
      }).catch(error => {
        console.log('error', error)
      })
    },
    openPage(event) {
      this.$router.push(event)
    },
    async fetchData() {
      let response = await axios.get('crm/v1/form_freeze/' + this.$route.query.id)
      this.getCSData(response.data.data.customer_service.id)
      this.addData = response.data.data

      const year = moment(this.addData.created_at).format('YYYY')
      const month = moment(this.addData.created_at).format('M')

      axios.get('crm/v1/closing_period/member_pt_session?year=' + year + '&bulan=' + month).then(response => {
        this.disableBtnSubmit = true
      }).catch(error => {
        // this.disabledExpiredDate = false
        console.log('error', error)
      })

      this.addData.freeze_revenue = this.addData.freeze_duration * 200000
      await this.getMember()
      let memberBranchId
      if (!response.data.data.branch) {
        memberBranchId = '(FT-' + response.data.data.member.id + ') ' + response.data.data.member.first_name + ' ' + response.data.data.member.last_name
      } else {
        memberBranchId = '(' + response.data.data.branch.codename + '-' + response.data.data.member.id + ') ' + response.data.data.member.first_name + ' ' + response.data.data.member.last_name
      }
      this.optionsMember.push({
        value: response.data.data.member.id, text: memberBranchId
      })
      axios.get('transaction/v1/payment_card?sorting=id&sorting_type=asc&status=active').then(response => {
        this.itemsPaymentCard = response.data.data.rows
      }).catch(error => {
        console.log('error', error)
      })
      axios.get('transaction/v1/payment_type?sorting=id&sorting_type=asc&status=active&payment_card_id=1').then(response => {
        this.itemsPaymentType = response.data.data.rows
        this.itemsPaymentType2 = response.data.data.rows
      }).catch(error => {
        console.log('error', error)
      })
      axios.get('crm/v1/customer_service?branch_id=' + this.addData.branch_id).then(response => {
        this.dataCS = response.data.data.rows
      }).catch(error => {
        console.log('error', error)
      })
      axios.get('fitness/v1/branch/').then(response => {
        this.dataBranch = response.data.data.rows
      }).catch(error => {
        console.log('error', error)
      })

      axios.get('crm/v1/form_freeze_category').then(response => {
        this.freeze_category = response.data.data
      }).catch(error => {
        console.log('error', error)
      })

      // turn off autocomplete
      if (document.getElementsByTagName) {
        var inputElements = document.getElementsByTagName("member_id")
        for (var i = 0; inputElements[i]; i++) {
          if (inputElements[i].className && (inputElements[i].className.indexOf("disableAutoComplete") != -1)) {
            inputElements[i].setAttribute("autocomplete", "off")
          }
        }
      }
    }
  },
  computed: {
    getMemberId: function () {
      return this.addData.member_id
    },
    totalPayment: function () {
      let calculatedTotal = this.addData.freeze_revenue
      this.amountPaymentCard1 = this.addData.freeze_revenue
      return calculatedTotal
    },
    paymentLeft: function () {
      if (String(this.amountPaymentCard1).length > String(this.addData.freeze_revenue).length) {
        // console.log('test')
        this.amountPaymentCard2 = 0
      } else {
        this.amountPaymentCard2 = this.addData.freeze_revenue - this.amountPaymentCard1
        this.amountPaymentCard2 = Math.abs(this.amountPaymentCard2)
      }
    }
  },
  watch: {
    getMemberId() {
      axios.get('fitness/v1/member/' + this.addData.member_id).then(response => {
        this.detailMember = response.data.data
        this.fullNameDetail = response.data.data.first_name + ' ' + response.data.data.last_name
        this.addDataPrivy.branch_id = response.data.data.branch_id
        this.addDataPrivy.member_id = response.data.data.id
      }).catch(error => {
        console.log('error', error)
      })
    }
  },
  created() {
    this.fetchData()
  }
}
</script>

<style></style>
